import { useSelector } from "react-redux";
import { MapIndicator } from "../index";
import { getIcons, parseDateFlexible } from "_helpers";
import { useEffect, useMemo, useState } from "react";
import { selectMapTotalBusCount } from "_store/selectors/map.selector";

export { DataInfoIndicator }

/**
 * Composant de la map affichant les informations (KPI) en bas à gauche
 * Indique le nombre de bus connectés ainsi que le moment de dernière mise à jour
 * Le nombre de bus provient du store redux 'map'
 * La date de mise à jour provient du store 'events'
 * @returns 
 */
function DataInfoIndicator()  {

    const lastEvents = useSelector(state => state.events?.data);

    const totalBusCount = useSelector(selectMapTotalBusCount);

    const [lastMajShort, setLastMajShort] = useState('');  

    useEffect(() => {        
        if (lastEvents?.date_last_event){
            
            const date_last_event = lastEvents.date_last_event
            const date_first_result = lastEvents.events[0].HEADER_EVTDATE;
            const date1 = parseDateFlexible(date_last_event);
            const date2 = parseDateFlexible(date_first_result);  
            const mostRecent = date1 > date2 ? date_last_event : date_first_result;

            const timePart = mostRecent.split(' ')[1];
            setLastMajShort(timePart);
        }
    }, [lastEvents])

    const data = useMemo(() => [
        {
            title: "Vehicules",
            value: totalBusCount,
            icon: getIcons("directionsBusFilledOutlinedWhite"),
            color: 'global-blue',
            isActiveClass: 'global-blue',
            clickable: false
        },
        {
            title: "Dernière mise à jour",
            value: lastMajShort,
            icon: getIcons("accessTimeOutlined"),
            color: 'global-blue',
            isActiveClass: 'global-blue',
            clickable: false,
        }
    ], [totalBusCount, lastMajShort]);

    return (
        <div className={"map-legend-bottom"}>
            <div className={'flex item-center mt-2'}>
                {data.map((e, index) => {
                    return <MapIndicator info={e} key={index} />
                })}
            </div>
        </div>


    )
}